/**
 * EzFlow ChatKit Integration — FlowE Assistant shell (1:1 port of www.ezflowe.com widget)
 * 壳规格取自 ezflowe.com live DOM（2026-08-22）：绿头部条 + 收起气泡，ChatKit 内芯默认样式
 */
(function() {
  var SESSION_API = 'https://ezflow-chatkit.duckdns.org/api/create-session';
  var WORKFLOW_ID = 'wf_69c3fd3e4d9c81908ce0515617d5506904c0c789584d0b51';
  var BRAND = '#47B27D';
  var sessionSecret = null;

  // Welcome once per browser, including when the visitor leaves it open.
  var welcomeKey = 'ezflow-chat-welcomed-v1';
  var shouldWelcome = false;
  try {
    shouldWelcome = window.localStorage.getItem(welcomeKey) !== '1' &&
      window.localStorage.getItem('ezflow-chat-dismissed-v1') !== '1';
    window.localStorage.setItem(welcomeKey, '1');
  } catch (e) {
    // If browser storage is unavailable, keep chat available without pop-ups.
    shouldWelcome = false;
  }

  // Pre-fetch session as soon as possible
  function fetchSession() {
    return fetch(SESSION_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ workflow: { id: WORKFLOW_ID } })
    })
    .then(function(r) { return r.json(); })
    .then(function(d) {
      if (d.client_secret) {
        sessionSecret = d.client_secret;
        return d.client_secret;
      }
      console.error('ChatKit: no client_secret', d);
      throw new Error('No client_secret');
    })
    .catch(function(e) {
      console.error('ChatKit: session fetch error', e);
      return new Promise(function(resolve) {
        setTimeout(function() { resolve(fetchSession()); }, 3000);
      });
    });
  }
  var sessionPromise = fetchSession();

  // ---- Shell styles (ported from ezflowe.com Tailwind classes) ----
  var css = [
    '#ezflow-chat-panel{position:fixed;right:16px;bottom:calc(env(safe-area-inset-bottom,0px) + 16px);z-index:9998;',
    'width:calc(100vw - 16px);height:min(72vh,640px);min-height:520px;overflow:hidden;border-radius:28px;',
    'border:1px solid rgba(0,0,0,.08);background:rgba(255,255,255,.9);-webkit-backdrop-filter:blur(24px);backdrop-filter:blur(24px);',
    'display:flex;flex-direction:column;transition:opacity .3s ease-out,transform .3s ease-out;',
    'transform:translateY(0) scale(1);opacity:1;pointer-events:auto;}',
    '@media(min-width:640px){#ezflow-chat-panel{width:320px}}',
    '@media(min-width:1024px){#ezflow-chat-panel{width:340px}}',
    '@supports(height:1dvh){#ezflow-chat-panel{height:min(72dvh,640px)}}',
    '#ezflow-chat-panel.ezflow-hidden{transform:translateY(16px) scale(.95);opacity:0;pointer-events:none;}',
    '#ezflow-chat-header{display:flex;align-items:center;justify-content:space-between;padding:12px 16px;color:#fff;background:' + BRAND + ';flex:none;}',
    '#ezflow-chat-header .ez-left{display:flex;align-items:center;gap:12px;}',
    '#ezflow-chat-header .ez-avatar{display:flex;height:36px;width:36px;align-items:center;justify-content:center;border-radius:9999px;background:rgba(255,255,255,.12);}',
    '#ezflow-chat-header .ez-title{font-weight:600;line-height:20px;font-size:15px;}',
    '#ezflow-chat-header .ez-status{display:flex;align-items:center;gap:8px;font-size:11px;color:#fff;}',
    '#ezflow-chat-min{display:flex;height:36px;width:36px;align-items:center;justify-content:center;border-radius:9999px;background:rgba(255,255,255,.1);color:#fff;border:none;cursor:pointer;transition:background .2s;}',
    '#ezflow-chat-min:hover{background:rgba(255,255,255,.2);}',
    '#ezflow-chat-shell{flex:1;min-height:0;overflow:hidden;background:#fff;}',
    '#ezflow-chat-shell openai-chatkit{display:block;height:100%;width:100%;}',
    '#ezflow-chat-launcher{position:fixed;right:16px;bottom:calc(env(safe-area-inset-bottom,0px) + 16px);z-index:9999;',
    'display:flex;height:64px;width:64px;align-items:center;justify-content:center;border-radius:9999px;border:none;cursor:pointer;',
    'color:#fff;background:' + BRAND + ';box-shadow:rgba(71,178,125,.35) 0 18px 50px;',
    'transition:transform .3s ease-out,opacity .3s ease-out;}',
    '#ezflow-chat-launcher:hover{transform:scale(1.05);}',
    '#ezflow-chat-launcher:active{transform:scale(.95);}',
    '#ezflow-chat-launcher.ezflow-hidden{opacity:0;pointer-events:none;transform:scale(.9);}'
  ].join('');
  var styleEl = document.createElement('style');
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  // ---- SVG icons (FontAwesome paths, extracted from reference site) ----
  function svgIcon(viewBox, d, size) {
    return '<svg viewBox="' + viewBox + '" width="' + size + '" height="' + size + '" aria-hidden="true" focusable="false"><path fill="currentColor" d="' + d + '"/></svg>';
  }
  var ICON_WAND = svgIcon('0 0 512 512', 'M464 6.1c9.5-8.5 24-8.1 33 .9l8 8c9 9 9.4 23.5 .9 33l-85.8 95.9c-2.6 2.9-4.1 6.7-4.1 10.7l0 21.4c0 8.8-7.2 16-16 16l-15.8 0c-4.6 0-8.9 1.9-11.9 5.3L100.7 500.9c-6.3 7.1-15.3 11.1-24.8 11.1-8.8 0-17.3-3.5-23.5-9.8L9.7 459.7c-6.2-6.2-9.7-14.7-9.7-23.5 0-9.5 4-18.5 11.1-24.8l111.6-99.8c3.4-3 5.3-7.4 5.3-11.9l0-27.6c0-8.8 7.2-16 16-16l34.6 0c3.9 0 7.7-1.5 10.7-4.1L464 6.1zM432 288c3.6 0 6.7 2.4 7.7 5.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8-14.8 51.7c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8l-14.8-51.7-51.7-14.8c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8 14.8-51.7c1-3.4 4.1-5.8 7.7-5.8zM87.7 69.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8-14.8 51.7c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8L57.5 166.5 5.8 151.7c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8 14.8-51.7c1-3.4 4.1-5.8 7.7-5.8s6.7 2.4 7.7 5.8zM208 0c3.7 0 6.9 2.5 7.8 6.1l6.8 27.3 27.3 6.8c3.6 .9 6.1 4.1 6.1 7.8s-2.5 6.9-6.1 7.8l-27.3 6.8-6.8 27.3c-.9 3.6-4.1 6.1-7.8 6.1s-6.9-2.5-7.8-6.1l-6.8-27.3-27.3-6.8c-3.6-.9-6.1-4.1-6.1-7.8s2.5-6.9 6.1-7.8l27.3-6.8 6.8-27.3c.9-3.6 4.1-6.1 7.8-6.1z', 14);
  var ICON_DOT = svgIcon('0 0 512 512', 'M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0z', 7);
  var ICON_CHEVRON = svgIcon('0 0 448 512', 'M201.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 338.7 54.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z', 14);
  var ICON_DOTS = svgIcon('0 0 512 512', 'M256 480c141.4 0 256-107.5 256-240S397.4 0 256 0 0 107.5 0 240c0 54.3 19.2 104.3 51.6 144.5L2.8 476.8c-4.8 9-3.3 20 3.6 27.5s17.8 9.8 27.1 5.8l118.4-50.7C183.7 472.6 218.9 480 256 480zM128 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z', 24);

  // ---- Build shell DOM ----
  var panel = document.createElement('div');
  panel.id = 'ezflow-chat-panel';
  panel.innerHTML =
    '<div id="ezflow-chat-header">' +
      '<div class="ez-left">' +
        '<div class="ez-avatar">' + ICON_WAND + '</div>' +
        '<div>' +
          '<div class="ez-title">FlowE Assistant</div>' +
          '<div class="ez-status">' + ICON_DOT + 'Online now</div>' +
        '</div>' +
      '</div>' +
      '<button type="button" id="ezflow-chat-min" aria-label="Minimize chat">' + ICON_CHEVRON + '</button>' +
    '</div>' +
    '<div id="ezflow-chat-shell"></div>';

  var launcher = document.createElement('button');
  launcher.type = 'button';
  launcher.id = 'ezflow-chat-launcher';
  launcher.setAttribute('aria-label', 'Open chat');
  launcher.innerHTML = ICON_DOTS;

  function openChat() {
    panel.classList.remove('ezflow-hidden');
    panel.removeAttribute('inert');
    panel.setAttribute('aria-hidden', 'false');
    launcher.classList.add('ezflow-hidden');
    launcher.setAttribute('aria-expanded', 'true');
    launcher.setAttribute('tabindex', '-1');
  }
  function closeChat() {
    panel.classList.add('ezflow-hidden');
    panel.setAttribute('inert', '');
    panel.setAttribute('aria-hidden', 'true');
    launcher.classList.remove('ezflow-hidden');
    launcher.setAttribute('aria-expanded', 'false');
    launcher.removeAttribute('tabindex');
  }
  launcher.setAttribute('aria-controls', 'ezflow-chat-panel');
  // Back/forward navigation must also restore the minimised widget.
  window.addEventListener('pagehide', closeChat);

  // Load ChatKit SDK, then show the one-time welcome or the corner launcher.
  var script = document.createElement('script');
  script.src = 'https://cdn.platform.openai.com/deployments/chatkit/chatkit.js';
  script.onload = function() {
    var chatkit = document.createElement('openai-chatkit');
    chatkit.setOptions({
      locale: 'en-AU',
      api: {
        getClientSecret: function(currentSecret) {
          if (currentSecret) return Promise.resolve(currentSecret);
          if (sessionSecret) return Promise.resolve(sessionSecret);
          return sessionPromise;
        }
      },
      theme: {
        colorScheme: 'light',
        color: {
          accent: {
            primary: '#47B27D',
            level: 2
          }
        }
      }
    });
    panel.querySelector('#ezflow-chat-shell').appendChild(chatkit);
    if (shouldWelcome) {
      openChat();
    } else {
      closeChat();
    }
    document.body.appendChild(panel);
    document.body.appendChild(launcher);
    panel.querySelector('#ezflow-chat-min').addEventListener('click', closeChat);
    launcher.addEventListener('click', openChat);
  };
  script.onerror = function() { console.error('ChatKit: SDK load failed'); };
  document.head.appendChild(script);
})();
